module.exports = __webpack_public_path__ + "static/media/logo_nav.bc2112b2.png";